import { create } from "zustand";

export interface LaunchPayload {
  /** Resolved gradient string (already dark/light-mode-aware) */
  bg: string;
  glowColor: string;
  iconColor: string;
  /** Icon element to float during the animation */
  icon: React.ReactNode;
  /** Centre X of the tapped card tile (viewport coords) */
  originX: number;
  /** Centre Y of the tapped card tile (viewport coords) */
  originY: number;
  /** Half-diagonal of the tapped tile — start radius of the circle */
  startRadius: number;
}

interface LaunchStore {
  payload: LaunchPayload | null;
  trigger: (p: LaunchPayload) => void;
  clear: () => void;
}

export const useLaunchStore = create<LaunchStore>((set) => ({
  payload: null,
  trigger: (p) => set({ payload: p }),
  clear: () => set({ payload: null }),
}));
